module.exports = __webpack_public_path__ + "img/check_3.52685622.svg";